import { AuthContext } from "context/AuthContext";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";

// Adjust selector to your actual auth state
// const selectIsAuthenticated = (state) => !!state.me?.me;

const BackButtonControl = () => {
  const location = useLocation();
  const { type } = useContext(AuthContext);
  // const navigate = useNavigate();
  // const isAuthenticated = useSelector(selectIsAuthenticated);

  // Fallback: also read from localStorage
  // const user = JSON.parse(localStorage.getItem("tireKicker-web") || "null");
  // const isUserLoggedIn = isAuthenticated || !!user;

  useEffect(() => {
    // console.log(location.pathname, "pathname");
    // if (location.pathname === "/otp") {
    //   if (type === "forgotPassword") {
    //     navigate("/forgot-password");
    //   }
    //   if (type === "resetPassword") {
    //     navigate("/recover-account");
    //   }
    // }
    // if (!isUserLoggedIn) return;
    // const userType = user?.user_type?.toLowerCase();
    // if (location.pathname === "/login" && userType) {
    //   console.log("Redirecting from /login because user is authenticated");
    //   // IMPORTANT: use replace to remove /login from history
    //   navigate(`/${userType}/home`, { replace: true });
    // }
  }, [location.pathname, type]);

  return null;
};

export default BackButtonControl;
